module.exports = __webpack_public_path__ + "img/rdpm.22288809.jpeg";